import { render, staticRenderFns } from "./info-add.vue?vue&type=template&id=985fbada&scoped=true&"
import script from "./info-add.vue?vue&type=script&lang=js&"
export * from "./info-add.vue?vue&type=script&lang=js&"
import style0 from "./info-add.vue?vue&type=style&index=0&id=985fbada&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "985fbada",
  null
  
)

export default component.exports